import React from 'react';
import { Box, Typography, IconButton, BoxProps, SxProps, Theme, useTheme } from '@mui/material';
import deepmerge from 'deepmerge';
import { BackIcon } from '@/public/icon';

interface FixedHeaderProps extends BoxProps {
    text: string | React.ReactNode;
    onClick: () => void;
    icon?: React.ReactNode | any;
    rightElement?: React.ReactNode;
    onRightElementClick?: () => void;
    maxWidth?: number;
    height?: number;
    sx?: SxProps;
}

const FixedHeader: React.FC<FixedHeaderProps> = ({ text, onClick, icon, rightElement, onRightElementClick, maxWidth = 768, height = 48, sx = {}, ...other }) => {
    const theme = useTheme();
    return (
        <Box
            sx={deepmerge<SxProps<Theme>>(
                {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: `${height}px`,
                    maxWidth: `${maxWidth}px`,
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: { mobile: '12px 20px', tablet: '12px 50px' },
                    zIndex: 1000,
                    margin: '0 auto',
                },
                sx
            )}
            {...other}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, gap: '10px' }}>
                {icon && (
                    <IconButton
                        onClick={onClick}
                        sx={{ m: -2, cursor: 'pointer' }}
                    >
                        {icon ?? <BackIcon color={theme.palette.grayscale.gray07} />}
                    </IconButton>
                )}
                <Typography
                    variant="h2_18Medium"
                    component="div"
                    sx={{ flexGrow: 1 }}
                >
                    {text}
                </Typography>
            </Box>
            {rightElement && (
                <Box
                    onClick={onRightElementClick}
                    sx={{ cursor: 'pointer' }}
                >
                    {rightElement}
                </Box>
            )}
        </Box>
    );
};

export default FixedHeader;
